import DAO from './DAO.js';
import StoreItemProcessing from '../helpers/StoreFunctions/StoreItemProcessing';
import _ from 'lodash';

export default class ProjectUsersDAO extends DAO {

  constructor(store) {
    super(store, 'project_user');
    this.unsetProjectUsers = this.unsetProjectUsers.bind(this);
    this.clearProjectUsers = this.clearProjectUsers.bind(this);
  }

  unsetProjectUsers(id) {
    StoreItemProcessing.deleteItemInStore(this.itemType, id);
  }

  clearProjectUsers() {
    StoreItemProcessing.clearItemsInStore(this.itemType);
  }

  clearState(options) {
    this.clearMyState(this.stateTree.new_project_users, null, this.unsetProjectUsers, this.clearProjectUsers, options);
  }
}



// WEBPACK FOOTER //
// ./src/dao/ProjectUsersDAO.js